var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('vs-button',{attrs:{"icon":"email","size":"small","disabled":!(_vm.nota.qtd_boletos > 0),"type":"relief","radius":"","color":"warning"},on:{"click":function($event){return _vm.confirmarEnvio()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }